import { render } from "./ValueListTable.vue?vue&type=template&id=2f36dc26"
import script from "./ValueListTable.vue?vue&type=script&lang=js"
export * from "./ValueListTable.vue?vue&type=script&lang=js"

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ValueListTable.vue"]])

export default __exports__